<ng-template #spinner>
  <div class="spinner-wrapper">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-container [ngSwitch]="tileTypeName">
  <!-- Common installation tile -->
  <ng-container *ngSwitchCase="InstallationHeaderTileTypeName.COMMON">
    <ng-container *ngIf="device.isNameLoaded || !device.boilerSerial; else spinner">
      <app-common-installation-tile [device]="device"></app-common-installation-tile>
    </ng-container>
  </ng-container>

  <!-- SolarLog tile -->
  <ng-container *ngSwitchCase="InstallationHeaderTileTypeName.SOLARLOG">
    <span class="tile-title">
      <ng-container
        *ngIf="
          (deviceThirdpartyModel$ | async | ready)?.properties?.value
            ?.value as deviceThirdpartyModel;
          else showDefaultTitle
        "
      >
        {{ deviceThirdpartyModel }}
      </ng-container>
      <ng-template #showDefaultTitle>
        {{ defaultTitleOfSolarLog }}
      </ng-template>
    </span>
  </ng-container>

  <!-- Eco water tile -->
  <ng-container *ngSwitchCase="InstallationHeaderTileTypeName.ECO_WATER">
    <div class="flex flex-col justify-between items-start flex-1">
      <span class="tile-title">
        <ng-container
          *ngIf="
            (deviceVariant$ | async | ready)?.properties?.value?.value as deviceVariant;
            else showDefaultTitle
          "
        >
          <span class="installation-title"
            >{{ deviceVariant | translateEcowaterDeviceVariant }}
          </span>
          <img *ngIf="brandLogo" class="mt-[-5px] ml-2" src="{{ brandLogo }}" />
        </ng-container>
        <ng-template #showDefaultTitle>
          {{ '+INSTALLATIONS.INSTALLATIONS.ECOWATER.ECOWATER_TITLE' | translate }}
        </ng-template>
      </span>
      <app-aggregated-status-pill
        [gatewaySerial]="device.gatewaySerial"
      ></app-aggregated-status-pill>
    </div>
  </ng-container>
</ng-container>
